import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@ting/ting-ui-components";
import { InfoOutlinedIcon } from "@ting/ting-ui-components/dist/icons";
export const MoreInfo = ({ onClick }) => {
    return (_jsx("span", { children: _jsx(Button, { v2: true, round: true, type: "neutral", onClick: onClick, variant: "ghost", startIcon: _jsx(InfoOutlinedIcon, { width: 24, height: 24 }) }) }));
};
